var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRightButtonArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 36 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.9 8.8V7.4L29.5 1l-1.4 1.4L32 6.3l1 .6-.1.3-1.1-.2H1v2h30.8l1.1-.1.1.3-.9.6-3.9 3.9 1.4 1.4z",
  className: "icon-right-button-arrow_svg__st0"
})));
export default SvgIconRightButtonArrow;